import { FC, useEffect, useState } from "react"
import { Outlet } from "react-router-dom"

import { ULoading } from "../components"
import { useAppDispatch } from "../core/app/hooks"
import { getPermissions } from "../core/app/slices/user/userApis"

const PermissionRoute: FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getPermissions()).then(() => {
      setIsLoading(false)
    })
  }, [])

  return isLoading ? <ULoading isLoading={true} /> : <Outlet />
}

export default PermissionRoute
